<template>
  <v-row no-gutters>
    <v-col cols="12">
      <redirect class="mb-5" title="Products" route="website.product-personalized" />
    </v-col>
    <v-col v-show="!loading" cols="12">
      <v-row no-gutters>
        <v-col cols="12" class="d-flex mb-7 align-center">
          <v-avatar tile size="70" color="#dddd" class="text-center pointer mr-3">
            <img
              :src="
                data && data.productId && data && data.productId.images[0]
                  ? imageHelpers.url(data && data.productId.imageSrcs[0])
                  : '@/assets/images/no-image.png'
              "
              alt=""
              srcset=""
            />
          </v-avatar>
          <h3 style="color:#4181cb">
            {{ data && data.productId ? data.productId.title : '' }}
          </h3>
        </v-col>
        <v-col cols="12" style="border-top: 1px solid silver;">
          <div class="text-center mb-2 mt-2" style=" width: 100%;">
            <h3>
              Preview Your Customization
            </h3>
          </div>
          <v-col cols="12" class="product-canvas d-flex justify-center align-center">
            <div class="personalize-production"></div>
          </v-col>
        </v-col>
        <v-col cols="12" class="my-4">
          <v-divider class=""></v-divider>
        </v-col>
        <v-col cols="12">
          <v-btn @click="deleteItem" color="error">Delete</v-btn>
          <v-btn
            class="ml-2"
            @click="$router.push({ name: 'website.product-personalized.update', params: { id: $route.params.id } })"
            color="primary"
            >Update</v-btn
          >
        </v-col>
      </v-row>
    </v-col>
    <v-overlay :value="overlay">
      <div class="fz-18">
        <v-progress-circular :size="30" color="primary" indeterminate></v-progress-circular>
      </div>
    </v-overlay>
  </v-row>
</template>

<script>
import { fabric } from 'fabric';
import imageHelpers from '@/helpers/image';
import { imageFake } from '@/const/image';
import { personalizesApi } from '@/apis/personalizes';
export default {
  data() {
    return {
      imageFake,
      loading: false,
      e1: 1,
      imageHelpers,
      canvas: {
        product: null,
        preview: null,
      },
      optionsProductSetting: {
        align: 'center',
        bold: false,
        fontColor: '#000000',
        fontSize: '25px',
        italic: false,
        underline: false,
        fontFamily: '',
        effect: 'STRAIGHT',
      },
      optionsPreviewSetting: {
        align: 'center',
        bold: false,
        fontColor: '#000000',
        fontSize: '25px',
        italic: false,
        underline: false,
        fontFamily: '',
        effect: 'STRAIGHT',
      },
      overlay: false,
      formData: {
        previewJson: null,
        productionJson: null,
      },
      imageUrl: {
        product: null,
        preview: null,
      },

      image: {
        src: null,
        size: {
          width: 0,
          height: 0,
        },
      },
      data: null,
      maxWidth: 0,
      listFontSize: [],
      previewSetting: {
        product: null,
        preview: null,
      },
    };
  },
  created() {
    for (let i = 11; i < 40; i++) {
      this.listFontSize.push({ name: `${i}px`, id: i });
    }
  },
  async mounted() {
    this.previewSetting.product = new fabric.Canvas('cpp');
    // this.previewSetting.preview = new fabric.Canvas('cprp');
    this.loading = true;
    this.overlay = true;
    await this.getData();
    this.loading = false;
    this.overlay = false;
  },
  methods: {
    async deleteItem() {
      try {
        await personalizesApi.remove(this.$route.params.id);
        this.$router.push({ name: 'website.product-personalized' });
      } catch (error) {}
    },
    async getData() {
      try {
        let res = await personalizesApi.getById(this.$route.params.id);

        if (res.data) {
          this.data = res.data;
          let parser = new DOMParser();
          let xmlDocProduct = res.data.productionSvg
            ? parser.parseFromString(res.data.productionSvg, 'text/xml')
            : null;
          if (xmlDocProduct && xmlDocProduct.querySelector('image')) {
            xmlDocProduct.querySelector('svg').setAttribute('width', '100%');
            xmlDocProduct.querySelector('svg').setAttribute('height', '100%');
            let attributes = xmlDocProduct.querySelector('image').attributes;
            document.querySelector('.personalize-production').style.width = parseFloat(attributes.width.value) + `px`;
            document.querySelector('.personalize-production').innerHTML = xmlDocProduct.querySelector('svg').outerHTML;
          }
        }
      } catch (error) {
        console.log('error', error);
      }
    },
  },
};
</script>

<style lang="scss">
.myFile {
  position: relative;
  overflow: hidden;
  float: left;
  clear: left;
}

.myFile input[type='file'] {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  font-size: 30px;
  filter: alpha(opacity=0);
}

.myFile2 input[type='file'] {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  font-size: 30px;
  filter: alpha(opacity=0);
}
.myFile2 {
  .btn-upload {
    background: #1f739e;
    font-weight: bold;
    color: white;
    padding: 8px 8px;
    display: flex;
    align-items: center;
    border-radius: 5px;
  }
}
</style>
